import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import PaymentProvider from "./PaymentProvider";
import { CreditCard, DollarSign, Wallet, Banknote, SmartphoneNfc } from "lucide-react";

const initialProviders = {
  stripe: {
    enabled: true,
    mode: 'test' as const,
    configured: true,
    name: 'Stripe',
    icon: CreditCard
  },
  paypal: {
    enabled: false,
    mode: 'test' as const,
    configured: false,
    name: 'PayPal',
    icon: DollarSign
  },
  mpesa: {
    enabled: true,
    mode: 'live' as const,
    configured: true,
    name: 'M-Pesa',
    icon: SmartphoneNfc
  },
  paystack: {
    enabled: false,
    mode: 'test' as const,
    configured: false,
    name: 'Paystack',
    icon: Wallet
  },
  momo: {
    enabled: true,
    mode: 'live' as const,
    configured: true,
    name: 'Mobile Money',
    icon: Banknote
  }
};

const PaymentProviderList = () => {
  const [providers, setProviders] = useState(initialProviders);

  const handleProviderToggle = (providerId: string) => {
    setProviders(prev => ({
      ...prev,
      [providerId]: {
        ...prev[providerId as keyof typeof providers],
        enabled: !prev[providerId as keyof typeof providers].enabled
      }
    }));
  };

  const handleModeChange = (providerId: string, mode: 'test' | 'live') => {
    setProviders(prev => ({
      ...prev,
      [providerId]: {
        ...prev[providerId as keyof typeof providers],
        mode
      }
    }));
  };

  return (
    <Accordion type="single" collapsible className="w-full">
      {Object.entries(providers).map(([key, provider]) => (
        <AccordionItem value={key} key={key}>
          <AccordionTrigger className="hover:no-underline">
            <div className="flex items-center gap-2">
              <provider.icon className="h-5 w-5" />
              <span>{provider.name}</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <PaymentProvider
              id={key}
              name={provider.name}
              icon={provider.icon}
              enabled={provider.enabled}
              mode={provider.mode}
              configured={provider.configured}
              onToggle={handleProviderToggle}
              onModeChange={handleModeChange}
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default PaymentProviderList;